import { initializeApp } from "firebase/app";
import { getAuth, signInWithCustomToken, signInWithEmailAndPassword, signOut } from "firebase/auth";
import { getFirestore, collection, getDocs, query, where, addDoc, Timestamp } from "firebase/firestore/lite";
import { getFunctions, httpsCallable } from "firebase/functions";
import { setConfig } from "../config.js";

export default class userLoggedCheckout {
  constructor() {
    console.log("bundle checkout 5.0");
    this.assine_environment = assine_environment[0];
    this.app = initializeApp(setConfig(this.assine_environment));
    this.auth = getAuth();
    this.db = getFirestore();
    this.usersColection = collection(this.db, "users");
    this.sessionCookieName = "session";
    this.actionGetUser = "";
    this.showModalLogin = true;
    this.authEndpoint = "https://us-central1-abril-id-testes-1528223718961.cloudfunctions.net/authUtils";

    this.functions = getFunctions();
    this.verifyUser =  httpsCallable(this.functions, 'verifyUser');
    this.userData = {};

    if( this.assine_environment == "sandbox"){
      this.authEndpoint = "https://us-central1-abril-id-homolog.cloudfunctions.net/authUtils";
    }
  
    this.autenticationFlow = false;
    this.crm = null;
    this.inputCheckout();
    this.syncAuth();
  }

  setCrossSession(idToken) {
    this.setTokenCookie(this.sessionCookieName, idToken, 1);
  }

  setCookie(cname, value, date) {
    var expires = '';
    if(date) {
      var d = date;
      expires = "expires="+ d.toUTCString();
    }
    document.cookie = cname+"="+value+";" + expires + ";domain=.abril.com.br;path=/";
  }

  eraseCookie(name) {
    document.cookie =
    name + "=;domain=abril.com.br; path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
  }
  
  setTokenCookie(name, value, days) {
    var expires = "";
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000 * 360);
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + ";domain=.abril.com.br;path=/";
  }

  signIn(){
    const $emailField = document.getElementById("signin-email");
    const $passwordField = document.getElementById("signin-password");
    const email = $emailField.value;
    const password = $passwordField.value;
    this.verifyUser({ email, password, viewUser: true }).then(async (res) => {

      switch (res.data.status) {
        case true:
          await this.authInFirebase(email, password, res.data);
        break;
        default:
          console.log("Erro ao tentar logar - Assinatura");
        break;
        }
    });

  }

  async authInFirebase(email, password, responseFromBackend) {
    console.log("authInFirebase", {email, password});
    try{
      signInWithEmailAndPassword(this.auth, email, password)
      .then( async (userCredential) => {
        if(userCredential.user.email){
          if(this.userData.tipo_login === null){
            this.userData.tipo_login = "abril";
          }
          const user = userCredential.user;
          this.atualuser = this.auth.currentUser;;
          this.showModalLogin = false;
          console.log("Usuário autenticado com sucesso!");
          this.listenAuthState();
        }else{
          console.log("Falha na autenticação");
        }
      });
    }catch(error) {
      console.log("Não conseguiu fazer o login");
    }
  };

  listenAuthState() {
    this.auth.onAuthStateChanged(async (user) => {
      if (user) {
        if (!user.isAnonymous && user.email && !this.autenticationFlow) {
          const userSnapshot = await query(
            this.usersColection,
            where("uid", "==", user.uid)
          );
          await getDocs(userSnapshot).then((querySnapshot) => {
            querySnapshot.forEach(async (doc) => {
              this.codClienteLogin = doc.data().codClienteLogin;
              this.userData.nome = doc.data().nomPessoa;
              this.userData.email = doc.data().dscEmail;
              this.userData.listaProjeto = doc.data().listaProjeto;
              this.userData.codClienteLogin = doc.data().codClienteLogin;
              this.userData.conteudoFavoritado = doc.data().conteudoFavoritado;
              this.userData.codPessoa = doc.data().codPessoa;
              this.userData.crm = doc.data().codClienteCrm;
              this.userData.cpf = this.cpfFormat(doc.data().numDocumento);
              this.crm = doc.data().codClienteCrm;
            });
          });
          this.setCrossSession(this.setHashCrm(this.crm));
          this.navegationData( user.uid, "checkout" );
          this.createCookieProductsUser(this.userData.listaProjeto);
          await this.userDataStorage();
          
          if (this.userData.nome !== "") {
            console.log("Storage do usuário criado com sucesso!");
            if(this.showModalLogin === true){
              this.isLogged(this.userData);
            }
            return;
          }
          
          return;
        } else {
          if (this.hasCrossSession()) {
            const crmCokie = this.getCrossSession();
            const crmToken = await this.setCustomToken( this.getHashCrm(crmCokie) );
            const userResponse = await signInWithCustomToken(this.auth, crmToken)
          } else {
            return;
          }
        }
      } else {
        if (this.hasCrossSession()) {
          //const idToken = this.getCrossSession();
          //const customToken = await this.getCustomToken(idToken);
          const crmCokie = this.getCrossSession();
          const crmToken = await this.setCustomToken( this.getHashCrm(crmCokie) );
          const userResponse = await signInWithCustomToken(this.auth, crmToken);
          return;
        } else {
          return;
        }
      }
    });
  }

  syncAuth() {
    try {
      this.listenAuthState();
    } catch (err) {
    }
  }

  metricUserStatus( status, permission ){

    if( status == "Assinante" && !permission ){
      status = "Registrado"
    }

    if(typeof gtag === 'undefined' ){
			setTimeout((e)=>{
				return this.metricUserStatus( status, permission )	;
			}, 1000);
		} else {
      return gtag('set', { 'dimension28': status });
		}
  }

  dimensionSign( direito, tipo ){

    if( tipo == "S/D" ){
      tipo = "N/A";
      if(direito.length == 0){
        direito = "N/A";
        tipo = "Ex-assinante";
      }else{
        direito = direito.join();
      }

    }

    if( Array.isArray(direito) && direito.length > 0){
      direito = direito.join();
      let combo = logged_paywall_combo[0].split(",");
      for(let i = 0; i < combo.length; i++){
        if (direito.indexOf(combo[i].toString()) != -1 && combo[i] != "") {
          tipo = "Combo";
        }
      }
    }
    AbrilCustomDimension.sendCustomDimension( { 'dimension29' : direito , 'dimension30' : tipo ,'non_interaction': true } );

  }

  async getCustomToken(idToken) {
    const response = await $.post({
      url: this.authEndpoint + "/getCustomToken",
      data: {
        idToken: idToken,
      },
      crossDomain: true,
      dataType: "json",
    }).promise();

    return response?.token;
  }

  hasCrossSession() {
    return this.getCookie(this.sessionCookieName) != null;
  }

  hasCookieLogin() {
    return this.getCookie('abrilDataUser') != null;
  }
  
  createCookieProductsUser(codes){
    var d = '';
    d = new Date();
    d.setTime( d.getTime() + (1000*60*60*24*30)) ;
    this.setCookie( 'AbrilProductsUser', codes, d );
    if( localStorage.getItem('AbrilProductsUser') == null ){
      localStorage.setItem('AbrilProductsUser', codes);
    }
  }

  getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  getCrossSession() {
    return this.getCookie(this.sessionCookieName);
  }

  crossSignOut() {
    this.eraseCookie(this.sessionCookieName);
    return;
  }
  
  hasCrossSession() {
    return this.getCookie(this.sessionCookieName) != null;
  }

  browserVersion = (userAgent,regex) => {
    return userAgent.match(regex) ? userAgent.match(regex)[2] : null;
  }

  detectBrowser(){

    const userAgent = navigator.userAgent;
    let browser = "unkown";
    // Detect browser name
    browser = (/ucbrowser/i).test(userAgent) ? 'UCBrowser' : browser;
    browser = (/edg/i).test(userAgent) ? 'Edge' : browser;
    browser = (/googlebot/i).test(userAgent) ? 'GoogleBot' : browser;
    browser = (/chromium/i).test(userAgent) ? 'Chromium' : browser;
    browser = (/firefox|fxios/i).test(userAgent) && !(/seamonkey/i).test(userAgent) ? 'Firefox' : browser;
    browser = (/; msie|trident/i).test(userAgent) && !(/ucbrowser/i).test(userAgent) ? 'IE' : browser;
    browser = (/chrome|crios/i).test(userAgent) && !(/opr|opera|chromium|edg|ucbrowser|googlebot/i).test(userAgent) ? 'Chrome' : browser;;
    browser = (/safari/i).test(userAgent) && !(/chromium|edg|ucbrowser|chrome|crios|opr|opera|fxios|firefox/i).test(userAgent) ? 'Safari' : browser;
    browser = (/opr|opera/i).test(userAgent) ? 'Opera' : browser;

    // detect browser version
    switch (browser) {
        case 'UCBrowser': return `${browser}/${this.browserVersion(userAgent,/(ucbrowser)\/([\d\.]+)/i)}`;
        case 'Edge': return `${browser}/${this.browserVersion(userAgent,/(edge|edga|edgios|edg)\/([\d\.]+)/i)}`;
        case 'GoogleBot': return `${browser}/${this.browserVersion(userAgent,/(googlebot)\/([\d\.]+)/i)}`;
        case 'Chromium': return `${browser}/${this.browserVersion(userAgent,/(chromium)\/([\d\.]+)/i)}`;
        case 'Firefox': return `${browser}/${this.browserVersion(userAgent,/(firefox|fxios)\/([\d\.]+)/i)}`;
        case 'Chrome': return `${browser}/${this.browserVersion(userAgent,/(chrome|crios)\/([\d\.]+)/i)}`;
        case 'Safari': return `${browser}/${this.browserVersion(userAgent,/(safari)\/([\d\.]+)/i)}`;
        case 'Opera': return `${browser}/${this.browserVersion(userAgent,/(opera|opr)\/([\d\.]+)/i)}`;
        case 'IE': const version = this.browserVersion(userAgent,/(trident)\/([\d\.]+)/i);
            // IE version is mapped using trident version
            // IE/8.0 = Trident/4.0, IE/9.0 = Trident/5.0
            return version ? `${browser}/${parseFloat(version) + 4.0}` : `${browser}/7.0`;
        default: return `unknown/0.0.0.0`;
    }
  }

  async navegationData( userId , loginType ){
    if( !userId || userId == "" || typeof userId == "undefined" ){
      return;
    }

    let data = Timestamp.fromDate(new Date());
    let device = navigator.userAgent;
    let browserName = this.detectBrowser();
    let dataUserNav = { "date" : data , "userAgent" : device , "browser" : browserName, "brand" : wp_paywall_vars.paywall_brand, "loginType" : loginType};
    let collRef = await collection( this.db , "users/"+userId+"/log_auth");
    try {
    await addDoc( collRef , dataUserNav );
    } catch (err) {
      console.error(err);
    }
    return;
  }

  inputCheckout() {
      this.campoName = "nome";
      this.campoEmail = "email";
      this.campoCpf = "identificacao_cpf_cnpj";
      this.campoTelefone = "tel";
      this.campoCep = "endereco_cep";
      this.campoLogradouro = "endereco_logradouro";
      this.campoNumero = "endereco_numero";
      this.campoComplemento = "endereco_complemento";
      this.campoBairro = "endereco_bairro";
      this.campoCidade = "endereco_cidade";
      this.campoUf = "endereco_uf";
      this.enderecofields = "endereco";
      this.isLoggedVerify = "isLoggedLigthbox";
      this.updateUser = "compraLogged";
      this.linkContinue = "javascript:;";
      this.actionGetUser = "data_is_logged_23";
      this.campoWhatsapp = "ind_comunicacao_whatsapp";
  }

  async isLogged(userDataValue) {
    document.getElementById("naologado").style.display = "none";
    document.getElementById("logado").style.display = "block";
    document.getElementById("logadoipt").value = "true";
    this.set_Abril_dataInputs(userDataValue.nome, userDataValue.email, "", userDataValue.cpf, "", "true", "false", "false");

    this.fieldPopulate(this.campoName, userDataValue.nome);
    this.fieldPopulate(this.campoEmail, userDataValue.email);
    this.fieldPopulate(this.campoCpf, userDataValue.cpf);

    let montaDadosInciais = "";
    
    let ul_logado = document.getElementById('logado');
    let ul_naologado = document.getElementById('naologado');

    if (userDataValue.nome.split(' ')[1] === undefined) {
      let copy_nome = document.querySelector('#nomeckp').cloneNode(true);
      document.querySelector('#nomeckp').remove();
      ul_logado.appendChild(copy_nome);
    }else{
      montaDadosInciais = "<strong>Nome: </strong>" + userDataValue.nome + "<br>";
    }
    
    if (userDataValue.email == "") {
      var copy_email = document.querySelector('#emailckp').cloneNode(true);
      document.querySelector('#emailckp').remove();
      ul_naologado.appendChild(copy_email);
    }else{
      montaDadosInciais += "<strong>E-mail: </strong>" + userDataValue.email.toLowerCase() + "<br>";
    }
    
    if(userDataValue.cpf === undefined  && userDataValue.cpf !== ""){
      let copy_cpf = document.querySelector('#cpfckp').cloneNode(true);
      document.querySelector('#cpfckp').remove();
      ul_logado.appendChild(copy_cpf);
    }else if(userDataValue.cpf.length === 14){
      montaDadosInciais += "<strong>CPF: </strong>" + userDataValue.cpf + "<br>";
    }else{
      montaDadosInciais += "<strong>CNPJ: </strong>" + userDataValue.cpf + "<br>";
    }
    document.getElementById("mostraDados").innerHTML = montaDadosInciais;

    if (document.getElementById(this.isLoggedVerify)) {
      let montaHtml = "<p>Você está logado como, <strong>" + userDataValue.nome + "</strong> ";
      montaHtml += "em sua conta <strong>" + userDataValue.email.toLowerCase() + "</strong>. Deseja continuar?</p>";

      document.getElementById(this.isLoggedVerify).style.display = "block";
      document.getElementById("userDados").innerHTML = montaHtml;
    }

    this.getUserData(userDataValue.crm).then((data) => {
      let ul_logado = document.getElementById('logado');
      let ul_naologado = document.getElementById('naologado');
      let infoUser = data;
      userCRM.codPessoa = data.cod;
      userCRM.crm = data.crm;
      if (typeof data.telefone !== "undefined") {
        const dddTel = this.telFormat(data.telefone);
        let mostraTel = "<strong>Celular:</strong> " + dddTel + "<br>";
        this.set_Abril_dataInputs(userDataValue.nome, userDataValue.email, dddTel, userDataValue.cpf, "", "true", "false", "false");
        this.fieldPopulate(this.campoTelefone, dddTel);
        document.getElementById("mostraDados").innerHTML = montaDadosInciais + mostraTel;

        var copy_tel = document.querySelector('#telckp').cloneNode(true);
        document.querySelector('#telckp').remove();
        ul_naologado.appendChild(copy_tel);

        let copy_news = document.querySelector('#newsletterckp').cloneNode(true);
        document.querySelector('#newsletterckp').remove();
        ul_logado.appendChild(copy_news);

        if (data.telefone.indComunicacaoWhatsapp === "S") {
          this.set_Abril_dataInputs(userDataValue.nome, userDataValue.email, dddTel, userDataValue.cpf, "", "true", "true", "false");
          document.getElementById(this.campoWhatsapp).checked = true;
        }else{
          let copy_whats = document.querySelector('#whatsappckp').cloneNode(true);
          document.querySelector('#whatsappckp').remove();
          ul_logado.appendChild(copy_whats);
        }
      }else{
        let copy_tel = document.querySelector('#telckp').cloneNode(true);
        let copy_whats = document.querySelector('#whatsappckp').cloneNode(true);
        let copy_news = document.querySelector('#newsletterckp').cloneNode(true);

        document.querySelector('#telckp').remove();
        document.querySelector('#whatsappckp').remove();
        document.querySelector('#newsletterckp').remove();

        let ul_logado = document.getElementById('logado');
        ul_logado.appendChild(copy_tel);
        ul_logado.appendChild(copy_whats);
        ul_logado.appendChild(copy_news);
      }

      if (
        typeof data.endereco !== "undefined" &&
        document.getElementById(this.enderecofields) !== null
      ) {
        let cep = this.cepFormat(data.endereco.cep);
        this.fieldPopulate(this.campoCep, cep);
        this.fieldPopulate(this.campoLogradouro, data.endereco.logradouro);
        this.fieldPopulate(this.campoNumero, data.endereco.nr);
        this.fieldPopulate(this.campoComplemento, data.endereco.complemento);
        this.fieldPopulate(this.campoBairro, data.endereco.bairro);
        this.fieldPopulate(this.campoCidade, data.endereco.cidade);
        this.fieldPopulate(this.campoUf, data.endereco.uf);
        if($("body").hasClass("checkout22")){
          this.fieldPopulate(this.campoWhatsapp, data.telefone);
        }
        if($("body").attr('data-frete') === 'S'){
          $('.loader').addClass('active');
          buscaFrete(cep);
        }
      }
    });
  }

  async getUserData(info) {
    return new Promise((resolve, reject) => {
      $.ajax({
        url: "/wp-admin/admin-ajax.php",
        method: "POST",
        async: true,
        dataType: "json",
        data: {
          action: this.actionGetUser,
          info: info,
        },
        success: function (data) {
          resolve(data);
        },
        error: function (error) {
          reject(error);
        },
      });
    });
  }

  telFormat(telData) {
    if(telData === undefined || telData === null || telData === ""){
      return;
    }

    let ddd = "(" + telData.numDdd + ") ";
    let tel = telData.numTelefone;
    if (telData.tipoTelefone) {
      const parte1 = tel.slice(0, 5);
      const parte2 = tel.slice(5, 9);
      tel = `${parte1}-${parte2}`;
    } else {
      const parte1 = tel.slice(0, 4);
      const parte2 = tel.slice(4, 8);
      tel = `${parte1}-${parte2}`;
    }
    return ddd + tel;
  }

  cepFormat(cepData) {
    if(cepData === undefined || cepData === null || cepData === ""){
      return;
    }
    const cep_p1 = cepData.slice(0, 5);
    const cep_p2 = cepData.slice(5, 8);
    const cep = `${cep_p1}-${cep_p2}`;
    return cep;
  }

  cpfFormat(cpfData) {

    if(cpfData === undefined || cpfData === null || cpfData === ""){
      return;
    }

    if(cpfData.length < 10){
      return;
    }

    if(cpfData.substr(0, 3) === '000'){
      cpfData = cpfData.substr(3, cpfData.length);
    }
    let cpf = '';
    if(cpfData.length === 11){
      const cpf_p1 = cpfData.slice(0, 3);
      const cpf_p2 = cpfData.slice(3, 6);
      const cpf_p3 = cpfData.slice(6, 9);
      const cpf_p4 = cpfData.slice(9, 11);
      cpf = `${cpf_p1}.${cpf_p2}.${cpf_p3}-${cpf_p4}`;
    }else{
      const cpf_p1 = cpfData.slice(0, 2);
      const cpf_p2 = cpfData.slice(2, 5);
      const cpf_p3 = cpfData.slice(5, 8);
      const cpf_p4 = cpfData.slice(8, 12);
      const cpf_p5 = cpfData.slice(12, 14);
      cpf = `${cpf_p1}.${cpf_p2}.${cpf_p3}/${cpf_p4}-${cpf_p5}`;
    }

    return cpf;
  }

  async signOut(reloadpage = true){
    console.log("Saindo");
    
    this.clearStorageUser();
    await signOut(this.auth).then(function() {
      console.log('Signed Out Lib');
    });
  
    this.updateScreen = false;
    this.eraseCookie("AbrilProductsUser");
    this.eraseCookie("amp-access");
    this.crossSignOut();
    this.clearStorageUser();
    const dimensionsGA4 = {
      "tipo_cadastro": "nao logado",
      "tipo_assinatura": "nao logado"
    }
    this.sendMetricsGA( 'metric2', 'Paywall', 'Logout Efetuado', "", dimensionsGA4);
    document.getElementById("logadoipt").value = "false";
    this.drop_Abril_dataInputs();
    console.log("Saindo fim");
    if (reloadpage === false) {
      return;
    }
    window.location.reload();
  }

  fieldPopulate(fiedname, value) {
    if(value !== undefined && value !== null && value !== ""){
      document.getElementById(fiedname).value = value;
    }
  }

  fieldChecked(fiedname, whatsapp) {

    let ul_logado = document.getElementById('logado');
    if (whatsapp==="N") {
      let copy_whats = document.querySelector('#whatsappckp').cloneNode(true);
      document.querySelector('#whatsappckp').remove();
      ul_logado.appendChild(copy_whats);
    }else{
      document.getElementById(fiedname).checked = true;
    }

    let copy_news = document.querySelector('#newsletterckp').cloneNode(true);
    document.querySelector('#newsletterckp').remove();
    ul_logado.appendChild(copy_news);

  }

  FechareContinuar() {
    document.getElementById(this.isLoggedVerify).style.display = "none";
  }

  set_Abril_dataInputs(nome, email, celphone, cpf, cardName, logado, whatsapp, newsletter) {
    window.localStorage.setItem(
      "abril_dataInputs",
      JSON.stringify({
        name: nome,
        email: email,
        celphone: celphone,
        cpf: cpf,
        cardName: cardName,
        logado: logado,
        checkout_whatsap: whatsapp,
        checkout_newsletter: newsletter
      })
    );
  }

  drop_Abril_dataInputs(){
    window.localStorage.setItem(
      "abril_dataInputs",
      JSON.stringify({
        name: "",
        email: "",
        celphone: "",
        cpf: "",
        cardName: "",
        logado: "false",
        checkout_whatsap: "false",
        checkout_newsletter: "false"
      })
    );
  }
  
  async userDataStorage() {
    if (!this.userData.nome) {
      return;
    }

    if(localStorage.getItem("abrilAssetsUser") !== null){
      let abrilAssetsUser = JSON.parse(localStorage.getItem("abrilAssetsUser"));
      this.userData.tipo_login = abrilAssetsUser.tipo_login
    }
    
    let data = {
      "nome": this.userData.nome,
      "email": this.userData.email,
      "crm": this.userData.crm,
      "tipo_login": this.userData.tipo_login
    };
    localStorage.setItem("abrilAssetsUser", JSON.stringify(data));
  }

  clearStorageUser() {
    localStorage.removeItem("abrilAssetsUser");
    localStorage.removeItem("abrilNotificacoes");
    localStorage.removeItem("AbrilProductsUser");
  }

  setHashCrm(v){
    v = v.toString();
    const t = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm','n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9','!','?','-'];
    let h = "";
    for(let w = 0; w < 50; w++){
      let i = t[Math.floor(Math.random() * (t.length))];
      if( Math.floor(Math.random() * 2)){
        i = i.toUpperCase();
      }
      let ij = t[Math.floor(Math.random() * (t.length))];
      if( Math.floor(Math.random() * 2)){
        ij = ij.toUpperCase();
      }
  
      if(w == 5){
        let tt = v.length;
        if (v.length < 10){
          tt = "0"+ v.length;
        }
        h = h + tt;
      }
  
      if(w == 8){
  
        for(let g=0; g < v.length; g++){
          let j = t[Math.floor(Math.random() * (t.length))];
          if( Math.floor(Math.random() * 2)){
            j = j.toUpperCase();
          }
          h = h + v[g] + j + ij;
  
        }
      }
      h = h + i ;
    }
    return h;
  }
  
  getHashCrm(h){
    let cr = ""
    for(let g=10; g < 10 + Number(h[5]+h[6])*3 ; g = g + 3){
      cr = cr + h[g];
    }
    return Number(cr);
  }

  signOutSSO() {
    console.log("User signed out signOutSSO.");
    this.signOut();
  }

  sendMetricsGA( metric, eventCategory, eventAction, eventLabel, dimensionsGA4 = ""){
		if ( typeOfMethodCompare(wp_paywall_vars) === "undefined" ) {
			setTimeout((e)=>{
				this.sendMetricsGA( metric, eventCategory, eventAction, eventLabel )	;
			}, 1000);
		} else {

			if ( this.isGaCreated === false ) {
        methodTagConfig(wp_paywall_vars.id_analytics_brand, '_ga'+paywall_brand[0], 'abril.com.br');
				this.isGaCreated = true;
			}

      let eventGa = {
        "metric": metric,
        "category": eventCategory,
        "action": eventAction,
        "label": eventLabel,
      };

      if( dimensionsGA4 !== ""){
        eventGa["dimensionsGA4"] = dimensionsGA4;
      }
      gaSendEvent(eventGa);
		}
	}

  async setCustomToken(param) {
    console.log("Auth: set custom token");
    let data = {}
    if(typeof param == 'number'){
      data = {
        crm: param
      }
    }else if(param.indexOf('@') != -1){
        data = {
          email: param
        }
    }else{
      return;
    }
   
    const response = await $.post({
      url: this.authEndpoint + "/setCustomToken",
      data: data,
      crossDomain: true,
      dataType: "json",
      complete: (xhr, statusText) => {
        return xhr.token;
      }
    }
    ).promise();

    return response?.token;
  }

  getParam(paramName){
    let queryString = window.location.search;
    let urlParams = new URLSearchParams(queryString);
    return urlParams.get(paramName);
  }
  
}
